
import { type FC } from 'react';
import { getSubtramiteEstado } from './getSubtramiteEstado';
import { Badge } from '@/components/ui/badge';
import { SubtramiteEstado } from './types';
import { cn } from '@/lib/utils';

export interface SubtramiteStatusBadgeProps {
  subtramite?: any;
  relative?: boolean;
  subtramiteKey?: string;
}

const ESTADOS_MAP: Record<SubtramiteEstado, { displayName: string; className: string }> = {
  "en-proceso": {
    displayName: "En Proceso",
    className: "bg-orange-100 text-orange-800",
  },
  "finalizado": {
    displayName: "Finalizado",
    className: "bg-green-100 text-green-800",
  },
  pendiente: {
    displayName: "Sin iniciar",
    className: "bg-gray-100 text-gray-800",
  },
}


function getDisplayName(estado: SubtramiteEstado, subtramiteKey: string): string {
  if (subtramiteKey === 'presupuestos' && estado === 'finalizado') {
    return 'Cobrado';
  }

  return ESTADOS_MAP[estado]?.displayName || "Desconocido";
}

const SubtramiteStatusBadge: FC<SubtramiteStatusBadgeProps> = ({
  subtramite,
  subtramiteKey,
  relative
}) => {
  const estado = getSubtramiteEstado(subtramite);
  const badgeClass = cn(
    "absolute top-2 right-2 bg-opacity-90",
    "px-2 py-1 rounded-full text-xs font-semibold",
    relative ? "relative top-0 right-0" : "",
    ESTADOS_MAP[estado]?.className || "bg-gray-500 text-white"
  );
  return (
    <Badge className={badgeClass}>
      {getDisplayName(estado, subtramiteKey)}
    </Badge>
  );
};

SubtramiteStatusBadge.displayName = 'SubtramiteStatusBadge';

export default SubtramiteStatusBadge;